import { apiGet } from '@/api/http';

import type { Education } from '@/types/reference';

const api_url = import.meta.env.VITE_API_URL;

export const getEducationList = () =>
  apiGet<Education[]>(`${api_url}education/`);
